/** Cookie name set by CapacitorProvider to signal native platform to the server */
export const CAPACITOR_COOKIE = 'capacitor';

/**
 * Token appended to the WebView user-agent by the native shell
 * (capacitor.config.json `appendUserAgent`, injected by build.sh and dev.sh in
 * both apps/ios and apps/android). Unlike the cookie above it is present on
 * the very first request of a fresh install, so the server can render the
 * native home immediately.
 * Keep in sync with the build scripts.
 */
export const CAPACITOR_UA_TOKEN = 'ZameelNative';
